import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import dayGridPlugin from '@fullcalendar/daygrid';
import FullCalendar from '@fullcalendar/react';
import { Skeleton, Stack, Typography } from '@mui/material';
import { generateRecurringEvents } from 'utils/recurringEvents';

import { TaskInfoDialog } from 'components/TaskInfoDialog';

import { useApi } from '../hooks/useApi';
import { Task } from '../types/task';

export const ScheduleCalendar = () => {
  const { user } = useUser();
  const { apiFetch } = useApi();
  const [tasks, setTasks] = useState(null);
  const [updatedTasks, setUpdatedTasks] = useState(null);
  const [activeTask, setActiveTask] = useState(null);

  const fetchTasks = async () => {
    const res = await apiFetch('tasks');
    const data = await res.json();

    const updated = data.flatMap((task: Task) => generateRecurringEvents(task));

    setTasks(data);
    setUpdatedTasks(updated);
  };

  useEffect(() => {
    if (user?.id) {
      fetchTasks();
    }
  }, [user?.id]);

  return (
    <>
      <Typography
        variant="h5"
        marginBottom="16px"
      >
        Task Schedule
      </Typography>
      <Stack
        overflow="auto"
        maxWidth="100%"
        sx={{
          border: '1px solid',
          borderColor: 'secondary.light',
          borderRadius: '20px',
        }}
      >
        <Stack
          pt={2}
          pb={2}
          px={3}
          gap={2}
        >
          {tasks ? (
            <FullCalendar
              eventTimeFormat={{
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }}
              themeSystem="yety"
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              fixedWeekCount={false}
              height="75vh"
              events={updatedTasks}
              eventClick={(info) => {
                setActiveTask({
                  ...tasks.find((task: Task) => task.id === +info.event.extendedProps.taskId),
                  status: info.event.extendedProps.status,
                });
              }}
            />
          ) : (
            <Skeleton
              variant="rounded"
              width="100%"
              height={300}
            />
          )}
        </Stack>
        <TaskInfoDialog
          onClose={() => setActiveTask(null)}
          open={!!activeTask}
          task={activeTask}
          refetch={fetchTasks}
        />
      </Stack>
    </>
  );
};
